export const LINKS = {
  TERMS_OF_USE_PDF_FOR_PATIENT: "/legal/terms-of-use-for-patient.pdf",
  TERMS_OF_USE_PDF_FOR_CLINIC: "/legal/terms-of-use-for-clinic.pdf",
  TERMS_OF_USE_PDF_FOR_COMPANY: "/legal/terms-of-use-for-company.pdf",
  PRIVACY_POLICY: "https://www.ntt-west.co.jp/share/privacy.html",
  OPERATING_COMPANY: "https://www.ntt-west.co.jp/",
  COMMERCIAL_TRANSCTION_ACT: "/legal/commercial-transaction-act.pdf",
} as const;

export type LinkKey = keyof typeof LINKS;

export const getLink = (key: LinkKey): string => LINKS[key];
